import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dfcf16cc")

_pushScopeId("data-v-dfcf16cc")
const _hoisted_1 = { class: "container edit-tag-container" }
const _hoisted_2 = { class: "edit-tag-header" }
const _hoisted_3 = { class: "edit-tag-content" }
const _hoisted_4 = { class: "edit-tag-filter" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "edit-tag-filter-btn" }, [
  /*#__PURE__*/_createVNode("button", { type: "button" }, [
    /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" })
  ])
], -1)
const _hoisted_6 = {
  key: 0,
  class: "add-subTag"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle pr-20" }, null, -1)
const _hoisted_8 = { class: "edit-tag-items" }
const _hoisted_9 = {
  key: 0,
  class: "edit-tag-item-edit-mode"
}
const _hoisted_10 = { class: "edit-mode-name" }
const _hoisted_11 = { class: "edit-mode-actions" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-check fs-14" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", {
  class: "icon-f icon-delete-cross fs-10",
  style: {"color":"#fd695a"}
}, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "edit-tag-item"
}
const _hoisted_15 = { class: "edit-tag-item-name" }
const _hoisted_16 = { class: "edit-tag-actions" }
const _hoisted_17 = { class: "edit-tag-footer" }
const _hoisted_18 = { class: "edit-tag-close" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.tagItem.id == -1 ? _ctx.$t('productTypeTitle') : _ctx.tagItem.name) + " ", 1),
      (!_ctx.isProductType)
        ? (_openBlock(), _createBlock("i", {
            key: 0,
            class: "icon-f icon-earth-shape fs-24 edit-main-tag-shape",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editTagLang()))
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          type: "text",
          placeholder: _ctx.$t('placeholder.search-by-tag-name'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterText = $event))
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.filterText]
        ]),
        _hoisted_5
      ]),
      (!_ctx.toEditItem || _ctx.toEditItem.id)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addSubTag()))
            }, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.$t('btn.add-new-tag')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_8, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subTagsItems, (tag, tagIndex) => {
          return (_openBlock(), _createBlock("div", {
            key: tagIndex + '-' + tag.id
          }, [
            (_ctx.toEditItem && _ctx.toEditItem.id == tag.id)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.toEditItem.mainLang.name = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.toEditItem.mainLang.name]
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.applyChanges()))
                    }, [
                      _hoisted_12
                    ]),
                    _createVNode("div", {
                      onClick: ($event: any) => (_ctx.rejectChanges(tagIndex))
                    }, [
                      _hoisted_13
                    ], 8, ["onClick"])
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, _toDisplayString(tag.mainLang.name), 1),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("i", {
                      class: "icon-f icon-earth-shape fs-18 sub-tag-langs",
                      onClick: ($event: any) => (_ctx.editSubTagLang(tag.id))
                    }, null, 8, ["onClick"]),
                    _createVNode("i", {
                      class: "icon-f icon-pencil-edit fs-18 sub-tag-edit",
                      onClick: ($event: any) => (_ctx.editSubTag(tag))
                    }, null, 8, ["onClick"]),
                    _createVNode("i", {
                      class: "icon-f icon-trash fs-18",
                      style: {"color":"#adacb7"},
                      onClick: ($event: any) => (_ctx.deleteEntity(tag.id))
                    }, null, 8, ["onClick"])
                  ])
                ]))
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
        }, _toDisplayString(_ctx.$t('button.close')), 1)
      ])
    ])
  ]))
})